import { useNavigate } from "react-router-dom";
import Typography from "../../Typography";

import {
  PodcastImage,
  PodcastCard as StyledPodcastCard,
  PodcastTitle,
  PodcastInfo,
  PodcastRatingStar,
  PodcastDescription,
  LiveFlag,
  PodcastImageWrapper,
  PodcastInfoWrapper,
  TitleWrapper,
} from "./styled";
import LiveIcon from "../../LiveIcon";

import { getReleaseEnding } from "../../../utils/utils";
import { AdultIconWithTooltip } from "../../AdultIconWithTooltip";

// Используется для создания последовательной анимации появления карточек подкастов.
// Значение вычисляется на основе индекса карточки в массиве (или 1, если индекс равен 0),
// что создает эффект появления карточек одна за другой с небольшими задержками.

export const PodcastCardMain = ({ podcast, duration }) => {
  let navigate = useNavigate();

  return (
    <StyledPodcastCard
      key={podcast.id}
      duration={duration * 500}
      onClick={() => navigate(`/podcasts/${podcast.podcastLink}`)}
      tabIndex={0}
    >
      <PodcastImageWrapper>
        <PodcastImage src={podcast.cover.big} alt={podcast.title} />
        {Object.keys(podcast.live).length > 0 && (
          <LiveFlag>
            <LiveIcon size="15" />
            <Typography component="span" variant="h2">
              ЛАЙВ
            </Typography>
          </LiveFlag>
        )}
      </PodcastImageWrapper>

      <PodcastInfoWrapper>
        <TitleWrapper>
          <Typography as={PodcastTitle} variant="h4">
            {podcast.title}
          </Typography>
          {podcast.isAdult && <AdultIconWithTooltip />}
        </TitleWrapper>
        <PodcastInfo>
          <PodcastRatingStar src="/star.svg" alt={podcast.avgRating} />
          <Typography>
            {podcast.avgRating} ({podcast.countRatings})
          </Typography>
          •
          <Typography>
            {podcast.countPodcastReleases}{" "}
            {getReleaseEnding(podcast.countPodcastReleases)}
          </Typography>
        </PodcastInfo>
        <Typography as={PodcastDescription} color="secondary">
          {podcast.description}
        </Typography>
      </PodcastInfoWrapper>
    </StyledPodcastCard>
  );
};
